import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './../pages/Home';
import About from './../pages/About';
import Services from './../pages/Services';
import Team from './../pages/Team';
import Contact from './../pages/Contact';
import Privacy from './../pages/Privacy';
import Imprint from './../pages/Imprint';

class Router extends Component {
    render() {
        
        return (
            <Switch>
                <Route exact path='/' component={Home}/>
                <Route path='/ueber-uns' component={About}/>
                <Route path='/service' component={Services}/>
                <Route path='/unser-team' component={Team}/>
                <Route path='/kontakt' component={Contact}/>
                <Route path='/datenschutz' component={Privacy}/>
                <Route path='/impressum' component={Imprint}/>
            </Switch>
        );
    }
}

export default Router;


// WEBPACK FOOTER //
// ./src/components/Router.js